import calendars from 'scoreboard/components/calendars'

import SummaryType from 'scoreboard/datasets/model/summary-type'
const { DAY_OF_THE_WEEK, MONTH_OF_THE_YEAR } = SummaryType
import { yearly, monthly, weekly, daily }
	from 'scoreboard/components/designer/valid-group-and-breakdown-calendars'

const GROUP = 'group'
const BREAKDOWN = 'breakdown'

function groupOrBreakdownCalendar ({ calendarId, summaryType, groupOrBreakdown }) {
	if (calendarId) {
		return calendars.calendarsById[calendarId]
	} else if (summaryType === DAY_OF_THE_WEEK) {
		if (groupOrBreakdown === GROUP) {
			return weekly
		} else if (groupOrBreakdown === BREAKDOWN) {
			return daily
		}
	} else if (summaryType === MONTH_OF_THE_YEAR) {
		if (groupOrBreakdown === GROUP) {
			return yearly
		} else if (groupOrBreakdown === BREAKDOWN) {
			return monthly
		}
	}
}

/**
 * If given a groupCalendarId, returns the "real" calendar defined in the database.
 * Otherwise, uses summaryType to determine the appropriate pseudo-calendar to
 * use as a group calendar.
 *
 * For example, for DAY_OF_WEEK, if the weekly calendar isn't defined in the
 * database, it will return the pseudo-calendar "weekly" defined in
 * valid-group-and-breakdown-calendars.js
 *
 * @param {Int} [groupCalendarId]
 * @param {SummaryType} [summaryType]
 */
function getGroupCalendar ({ groupCalendarId, summaryType }) {
	return groupOrBreakdownCalendar({
		calendarId: groupCalendarId,
		summaryType,
		groupOrBreakdown: GROUP
	})
}

/**
 * If given a breakdownCalendarId, returns the "real" calendar defined in the database.
 * Otherwise, uses summaryType to determine the appropriate pseudo-calendar to
 * use as a breakdown calendar.
 *
 * For example, for DAY_OF_WEEK, if the daily calendar isn't defined in the
 * database, it will return the pseudo-calendar "daily" defined in
 * valid-group-and-breakdown-calendars.js
 *
 * @param {Int} [breakdownCalendarId]
 * @param {SummaryType} [summaryType]
 */
function getBreakdownCalendar ({ breakdownCalendarId, summaryType }) {
	return groupOrBreakdownCalendar({
		calendarId: breakdownCalendarId,
		summaryType,
		groupOrBreakdown: BREAKDOWN
	})
}

export { getGroupCalendar, getBreakdownCalendar }
